<template>
  <div class="d-flex flex-column">
    <SidebarItem
      class="order-md-0 order-3"
      text="Minha jornada"
      to="/aluno"
      :img="true"
    >
      <template #img>
        <img src="/images/icons/home.svg">
      </template>
    </SidebarItem>
    <SidebarItem
      class="order-md-2 order-1"
      text="Calendário"
      :to="{
        name: calendarRouteName,
        query: { cycle_config_id: selectedCycle.id }
      }"
      :img="true"
    >
      <template #img>
        <img src="/images/icons/calendar.svg">
      </template>
    </SidebarItem>
    <SidebarItem
      class="order-md-2 order-1"
      text="Estude agora"
      :to="{
        name: studyNowRouteName,
        query: { cycle_config_id: selectedCycle.id }
      }"
      :img="true"
    >
      <template #img>
        <img src="/images/icons/book.svg">
      </template>
    </SidebarItem>
    <SidebarItem
      v-if="$route.name != homeRouteName"
      class="order-md-3 order-0"
      text="Relatórios"
      :to="{ name:'student.metric.index', query: { cycle_config_id: selectedCycle.id } }"
      :img="true"
    >
      <template #img>
        <img src="/images/icons/report_icon.svg">
      </template>
    </SidebarItem>
  </div>
</template>
<script>

import SidebarItem from "@/common/components/sidebar/SidebarItem.vue";
import { studyNowRouteName, homeRouteName, calendarRouteName } from '@/student/constants/routes';
import { mapGetters } from "vuex";

export default {
  components:{
    SidebarItem,
  },
  data(){
    return {
      homeRouteName,
      calendarRouteName,
      studyNowRouteName,
    }
  },
  computed: {
    ...mapGetters([
      'currentCycleHasModules',
      'currentCycleIsFinished',
      'selectedCycle',
    ]),
  },
  }
</script>
